import GROUP_ONE from "./query.gql";
import { ScopeData } from "@/graphql/scopeData";

export interface GroupVariables {
  id: string;
}

export interface UserData {
  id: string;
  loginId: string;
  name: string;
  email: string;
  scopes: ScopeData[];
}

export interface GroupData {
  id: string;
  name: string;
  isPrivileged: boolean;
  allowRescueOperations: boolean;
  users: UserData[];
}

export interface GroupOneData {
  group: GroupData;
}

export { GROUP_ONE };
